/**
 * backend-api
 * LoopBack Application
 *
 * OpenAPI spec version: 4.41.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ObjectID from './ObjectID';

/**
* The CompanyAccountBrand model module.
* @module model/CompanyAccountBrand
* @version 4.41.0
*/
export default class CompanyAccountBrand {
    /**
    * Constructs a new <code>CompanyAccountBrand</code>.
    * @alias module:model/CompanyAccountBrand
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>CompanyAccountBrand</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CompanyAccountBrand} obj Optional instance to populate.
    * @return {module:model/CompanyAccountBrand} The populated <code>CompanyAccountBrand</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompanyAccountBrand();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ObjectID.constructFromObject(data['id']);
            }
            if (data.hasOwnProperty('companyAccountId')) {
                obj['companyAccountId'] = ObjectID.constructFromObject(data['companyAccountId']);
            }
            if (data.hasOwnProperty('brandId')) {
                obj['brandId'] = ObjectID.constructFromObject(data['brandId']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/ObjectID} id
    */
    id = undefined;
    /**
    * @member {module:model/ObjectID} companyAccountId
    */
    companyAccountId = undefined;
    /**
    * @member {module:model/ObjectID} brandId
    */
    brandId = undefined;




}
